export function registerSW() {
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    const hadController = !!navigator.serviceWorker.controller;
    navigator.serviceWorker
      .register("/service-worker.js", { updateViaCache: "none" })
      .then((reg) => {
        // Force an immediate update check on load.
        reg.update().catch(() => {});

        // Keep checking for a fresh build: on tab focus and every 60s.
        const checkForUpdate = () => reg.update().catch(() => {});
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") checkForUpdate();
        });
        setInterval(checkForUpdate, 60 * 1000);

        // When a new SW is found, activate it right away.
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              nw.postMessage?.({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch(() => {});

    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      // Only reload on a genuine SW UPDATE (a controller already existed).
      // Never reload on the first-visit clients.claim() — that wipes in-flight
      // UI state (e.g. a guest mid-join or a user in a live call).
      if (!hadController) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
